import { render, staticRenderFns } from "./LayoutMainFull.vue?vue&type=template&id=3573a141&scoped=true&"
import script from "./LayoutMainFull.vue?vue&type=script&lang=js&"
export * from "./LayoutMainFull.vue?vue&type=script&lang=js&"
import style0 from "./LayoutMainFull.vue?vue&type=style&index=0&id=3573a141&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3573a141",
  null
  
)

export default component.exports